var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAddCircleLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9.65C16.4142 9.65 16.75 9.98579 16.75 10.4V15.25H21.6C22.0142 15.25 22.35 15.5858 22.35 16C22.35 16.4142 22.0142 16.75 21.6 16.75H16.75V21.6C16.75 22.0142 16.4142 22.35 16 22.35C15.5858 22.35 15.25 22.0142 15.25 21.6V16.75H10.4C9.98579 16.75 9.65 16.4142 9.65 16C9.65 15.5858 9.98579 15.25 10.4 15.25H15.25V10.4C15.25 9.98579 15.5858 9.65 16 9.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2.75C8.68223 2.75 2.75 8.68223 2.75 16C2.75 23.3178 8.68223 29.25 16 29.25C23.3178 29.25 29.25 23.3178 29.25 16C29.25 8.68223 23.3178 2.75 16 2.75ZM1.25 16C1.25 7.8538 7.8538 1.25 16 1.25C24.1462 1.25 30.75 7.8538 30.75 16C30.75 24.1462 24.1462 30.75 16 30.75C7.8538 30.75 1.25 24.1462 1.25 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddCircleLined);
export default __webpack_public_path__ + "static/media/ic_add_circle_lined.3d63e3bcb37031c2b5e6437a14d97c12.svg";
export { ForwardRef as ReactComponent };